<mat-expansion-panel class="your-info-expansion"
  [expanded]="isEditMode && (!step.valid || step.controls?.firstName?.dirty || step.controls?.lastName?.dirty || step.controls?.email?.dirty || step.controls?.phoneNumber?.dirty || step.controls?.customerType?.dirty || step.controls?.businessName?.dirty)"
  *ngIf="selectedIndex === 0">
  <mat-expansion-panel-header>
    <mat-panel-title class="step-title">
      {{ 'service.contactInformation' | translate}}
    </mat-panel-title>
    <mat-panel-description class="form-status">
      <span class="in-complete" *ngIf="!step.valid"> {{ 'deliveryChecklist.formIncomplete' | translate}}</span>
      <span class="complete" *ngIf="step.valid">{{ 'deliveryChecklist.formComplete' | translate}}</span>
    </mat-panel-description>
  </mat-expansion-panel-header>
  <form [formGroup]='step' appConnectStore="customerForm">
    <div class="your-container">
      <div class='your-info'>
        <div class='contact-form'>
          <!--ASPD-6589 changes(Don't remove)-->
          <div class="field-input business-name">
            <mat-checkbox
              [checked]="f.customerType?.value === 'Business'"
              (change)="onCustomerTypeChange($event.checked)">
              {{ 'searchCustomer.customerType' | translate }}
            </mat-checkbox>
          </div>
          <div class="field-input business-name" *ngIf="f.customerType?.value === 'Business'">
            <label class="required">{{ 'searchCustomer.businessName' | translate }}</label>
            <mat-form-field appearance="outline">
              <input matInput formControlName="businessName" required />
              <mat-error *ngIf="f.businessName?.invalid">{{ 'searchCustomer.pleaseEnterBusinessName' | translate }}</mat-error>
            </mat-form-field>
          </div>
          <!--ASPD-6589 changes(Don't remove)-->
          <div class='contact-info'>
            <div class="field-input firstName">
              <label [ngClass]="{ 'required': isControlRequired('firstName') }">{{ 'searchCustomer.firstName' |
                translate}}</label>
              <mat-form-field appearance="outline">
                <input matInput formControlName='firstName' required>
                <mat-error *ngIf="f.firstName?.invalid">{{ 'testDrive.pleaseEnterFirstName' | translate}}</mat-error>
              </mat-form-field>
            </div>

            <div class="field-input lastname">
              <label [ngClass]="{ 'required': isControlRequired('lastName') }">{{ 'searchCustomer.lastName' |
                translate}}</label>
              <mat-form-field appearance="outline">
                <input matInput formControlName='lastName' required>
                <mat-error *ngIf="f.lastName?.invalid">{{ 'testDrive.pleaseEnterLastName' | translate}}</mat-error>
              </mat-form-field>
            </div>
            <div class="empty"></div>

            <div class="field-input email">
              <label>{{ 'testDrive.email' | translate}}</label>
              <mat-form-field appearance="outline">
                <input matInput formControlName='email'>
                <mat-error *ngIf="f.email?.invalid">{{ 'testDrive.pleaseEnterValidEmail' | translate}}</mat-error>
              </mat-form-field>
            </div>
            <div class="field-input mob-num">
              <label class="required">{{ 'testDrive.mobileNumber' | translate}}</label>
              <mat-form-field appearance="outline" class="contact-number">
                <input matInput type="text" placeholder="" formControlName="phoneNumber" appPhoneFormat inputMode="numeric"
                  [errorStateMatcher]="matcher" />
                <mat-error>{{ 'testDrive.PleaseEnterValidPhone' | translate }}</mat-error>
              </mat-form-field>
              </div>
            <div class="search-buttons" *ngIf="!isEditMode">
              <button type="button" class="search-btn" (click)="searchCustomer()" [disabled]="disableSearchBtn()">
                <span>{{ 'searchCustomer.search' | translate }}</span>
              </button>
              <div class="error-message" *ngIf="noCustomerFound">
                {{ 'serviceSchedule.noCustomerResults' | translate }}
              </div>
            </div>
          </div>
          <app-do-not-modify-banner *ngIf="isDRVAFlagSet"></app-do-not-modify-banner>
        </div>
      </div>
    </div>
  </form>
</mat-expansion-panel>
<mat-expansion-panel class="your-info-expansion" *ngIf="selectedIndex === 0"
  [expanded]="isEditMode && step.controls?.appointmentComments?.dirty">
  <mat-expansion-panel-header>
    <mat-panel-title class="step-title">
      {{ 'service.additionalComments' | translate}}
    </mat-panel-title>
  </mat-expansion-panel-header>
  <form [formGroup]='step' class='comments-info'>
    <mat-form-field class="no-fixed-height" appearance="outline">
      <textarea matInput rows='5' maxlength="250" placeholder="{{ 'delivery.placeHolderComments' | translate}}"
        formControlName='appointmentComments'></textarea>
    </mat-form-field>
    <mat-hint
      style="display: flex; flex-direction: row-reverse; font-size: 0.8rem; font-weight: bold;">{{step.controls?.appointmentComments?.value?.length
      || 0}}/250 {{ 'delivery.characters' | translate}}</mat-hint>
    <div class='additional-comments-error'>
      <asp-icon name="ic-20-feedback-alert-error.svg" width="1rem"></asp-icon> {{'service.specialCharactersNotAllowed' |
      translate}}
    </div>
  </form>
</mat-expansion-panel>

<div class='appointment-container' *ngIf="selectedIndex === 2">
  <form [formGroup]='step' appConnectStore="customerForm">
    <div class='container-header'>
      <div class='choose'>{{ 'service.chooseTheAppointment' | translate}}</div>
      <div class='choose-desc'>{{ 'testDrive.preferredTransLanguageAdvisorApptTimeRequestText' | translate}}
      </div>
    </div>
    <app-splitter class='app-splitter' [config]="'horizontal 100% 0 -.4rem 550px'"></app-splitter>
    <div class='container-header'>
      <div class='choose'>{{ 'service.transportation' | translate}}</div>
    </div>
    <section class='transport-container'>
      <span *ngIf="!isValidTransport" class="required" style="color: black">{{ 'serviceSchedule.choosePreferredTransportOption' | translate
        }}</span>
      <app-toggle-location class='app-toggle-location' formControlName="transport"
        (click)="checkZipCodes(step.value.remoteZipCode)" [allTransportOptions]="transportOptions$ | async"
        [department]="department" (validateTransport)="checkFormValidity($event)">
      </app-toggle-location>
      <ng-container
        *ngIf="(step.value.transport === 'REMOTE' || step.value.transport === 'PICKUP' || step.value.transport === 'DELIVERY')">
        <div style="font-size: 0.8rem;">{{ 'service.enterZipCodeToCheckServiceTxt' | translate}}</div>
        <div class="zip" [ngClass]="{'error' : !isValidRemoteZip}">
          <div class="field-input mob-num">
            <label class="required">{{ 'common.Zipcode' | translate}}</label>
            <mat-form-field appearance="outline" class="error-outside">
              <input matInput required #zip [placeholder]=" 'common.Zipcode' | translate" formControlName="remoteZipCode"
                (input)="checkZipCodes(zip.value)" />
              <mat-error>{{ 'service.sorryRemoteServicesAreNotAvailableTxt' | translate}}
              </mat-error>
            </mat-form-field>
          </div>
          <div class="tick" [ngClass]="{'selected' : isValidRemoteZip}"></div>
        </div>
      </ng-container>
    </section>

    <div class="your-container">
      <div class='your-info'>
        <div class='contact-form'>
          <app-splitter *ngIf="(step.value.transport === 'REMOTE' || step.value.transport === 'PICKUP')" class='app-splitter'
            [config]="'horizontal 100% 0 -.4rem 550px'"></app-splitter>
          <!-- Address details -->
          <section>
            <div *ngIf="(step.value.transport === 'REMOTE' || step.value.transport === 'PICKUP')" class='location-header'>
              {{ 'service.locationForVehiclePickup' | translate}}
            </div>
            <app-shared-address *ngIf="(step.value.transport === 'REMOTE' || step.value.transport === 'PICKUP')"
              [form]="step.controls.pickUpAddress" [zipCodes]="remoteValidZipcodes" (zipChange)="zipChange($event,'pickUpAddress')"
              [formStates]="formStates['pickUpAddress'].states" [formcities]="formcities['pickUpAddress'].cities.statecities"
              (addressChange)="updateAddressFields($event,'pickUpAddress')"
              [remotelocation]="this.step.controls.isRemoteLocation.value">
            </app-shared-address>

            <app-splitter *ngIf="(step.value.transport === 'DELIVERY' || step.value.transport === 'REMOTE')" class='app-splitter'
              [config]="'horizontal 100% 0 -.4rem 550px'"></app-splitter>

            <div *ngIf="(step.value.transport === 'DELIVERY' || step.value.transport === 'REMOTE')" class='location-header'>
              {{ 'service.locationForVehicleDrop-Off' | translate}}
            </div>
            <div *ngIf="(step.value.transport === 'REMOTE')" class='pickup-header'>
              <div class="fltLeft">{{ 'service.sameAsPickupLocation' | translate}}</div>
              <div class="fltRight">
                <app-onofswitch [switchInput]='isPickUpLocationSame'
                  (switchChange)="updateSwitchValues($event, 'pickuplocationsame')" [customText]="true">
                </app-onofswitch>
              </div>
            </div>
            <!-- dropoff address details -->
            <!--this is for delivery only scenario,if the toggle for same address is off, read pickup address otherwise dropoff address-->
            <div *ngIf="(step.value.transport === 'DELIVERY')">
              <app-shared-address [form]="isPickUpLocationSame? step.controls.pickUpAddress : step.controls.dropOffAddress"
                [zipCodes]="remoteValidZipcodes"
                (addressChange)="isPickUpLocationSame ? updateAddressFields($event,'pickUpAddress') :updateAddressFields($event,'dropOffAddress')"
                [formStates]="isPickUpLocationSame ? formStates['pickUpAddress'].states : formStates['dropOffAddress'].states"
                [formcities]="isPickUpLocationSame ? formcities['pickUpAddress'].cities.statecities : formcities['dropOffAddress'].cities.statecities"
                (zipChange)="isPickUpLocationSame ? zipChange($event,'pickUpAddress') : zipChange($event,'dropOffAddress')"
                [remotelocation]="this.step.controls.isRemoteLocation.value">
              </app-shared-address>
            </div>

            <!--this is for remote pickup and dropoff scenario-->
            <div *ngIf="!isPickUpLocationSame && (step.value.transport === 'REMOTE') ">
              <app-shared-address [form]="step.controls.dropOffAddress" [zipCodes]="remoteValidZipcodes"
                (addressChange)="updateAddressFields($event,'dropOffAddress')"
                [formStates]="formStates['dropOffAddress'].states"
                [formcities]="formcities['dropOffAddress'].cities.statecities"
                (zipChange)="zipChange($event,'dropOffAddress')"
                [remotelocation]="this.step.controls.isRemoteLocation.value">
              </app-shared-address>
            </div>


          </section>
          <ng-container *ngIf="isCustomerAddressMandate">
            <section>
              <div class='location-header'>
                {{ 'service.homeLocation' | translate}} <span style="color: red">*</span>
              </div>
              <div *ngIf="isRemoteAddressZip">
                <div *ngIf="isRemoteLocation">
                  <div class='pickup-header'>
                    <div class="fltLeft">{{ 'service.sameAsPickupLocation' | translate}}</div>
                    <div class="fltRight">
                      <app-onofswitch [switchInput]='isHomeLocationSame' (switchChange)="updateSwitchValues($event, 'homelocationsame')"
                        [customText]="'Yes/No'">
                      </app-onofswitch>
                    </div>
                    </div>
                </div>
              </div>
              <ng-container *ngIf=" !isHomeLocationSame">
                <app-shared-address [form]="step.controls.customerAddress" [zipCodes]="remoteValidZipcodes"
                  [isCustomerAddress]="isCustomerAddressMandate" (zipChange)="zipChange($event,'customerAddress')"
                  [formStates]="formStates['customerAddress'].states" [formcities]="formcities['customerAddress'].cities.statecities"
                  [remotelocation]="this.step.controls.isRemoteLocation.value">
                </app-shared-address>
              </ng-container>
            </section>
          </ng-container>
          <!-- end: Address details -->
        </div>
      </div>
    </div>
  </form>
</div>